import "core-js/modules/es.array.reverse.js";
var _class, _FeatureServerStratum;
import "core-js/modules/es.symbol.description.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import i18next from "i18next";
import { action, computed, runInAction, makeObservable } from "mobx";
import URI from "urijs";
import filterOutUndefined from "../../../Core/filterOutUndefined";
import isDefined from "../../../Core/isDefined";
import loadJson from "../../../Core/loadJson";
import replaceUnderscores from "../../../Core/replaceUnderscores";
import runLater from "../../../Core/runLater";
import { networkRequestError } from "../../../Core/TerriaError";
import CatalogMemberMixin from "../../../ModelMixins/CatalogMemberMixin";
import GroupMixin from "../../../ModelMixins/GroupMixin";
import UrlMixin from "../../../ModelMixins/UrlMixin";
import ArcGisFeatureServerCatalogGroupTraits from "../../../Traits/TraitsClasses/ArcGisFeatureServerCatalogGroupTraits";
import { InfoSectionTraits } from "../../../Traits/TraitsClasses/CatalogMemberTraits";
import ArcGisFeatureServerCatalogItem from "./ArcGisFeatureServerCatalogItem";
import CommonStrata from "../../Definition/CommonStrata";
import CreateModel from "../../Definition/CreateModel";
import createStratumInstance from "../../Definition/createStratumInstance";
import LoadableStratum from "../../Definition/LoadableStratum";
import proxyCatalogItemUrl from "../proxyCatalogItemUrl";
import StratumOrder from "../../Definition/StratumOrder";
export let FeatureServerStratum = (_class = (_FeatureServerStratum = class FeatureServerStratum extends LoadableStratum(ArcGisFeatureServerCatalogGroupTraits) {
  constructor(_catalogGroup, _featureServer) {
    super();
    this._catalogGroup = _catalogGroup;
    this._featureServer = _featureServer;
    makeObservable(this);
  }
  duplicateLoadableStratum(model) {
    return new FeatureServerStratum(model, this._featureServer);
  }
  get featureServerData() {
    return this._featureServer;
  }
  get name() {
    if (this._featureServer.documentInfo && this._featureServer.documentInfo.Title && this._featureServer.documentInfo.Title.length > 0) {
      return replaceUnderscores(this._featureServer.documentInfo.Title);
    }
  }
  get info() {
    return [createStratumInstance(InfoSectionTraits, {
      name: i18next.t("models.arcGisFeatureServerCatalogGroup.serviceDescription"),
      content: this._featureServer.serviceDescription
    }), createStratumInstance(InfoSectionTraits, {
      name: i18next.t("models.arcGisFeatureServerCatalogGroup.dataDescription"),
      content: this._featureServer.description
    }), createStratumInstance(InfoSectionTraits, {
      name: i18next.t("models.arcGisFeatureServerCatalogGroup.copyrightText"),
      content: this._featureServer.copyrightText
    })];
  }
  get cacheDuration() {
    if (isDefined(super.cacheDuration)) {
      return super.cacheDuration;
    }
    return "1d";
  }
  get dataCustodian() {
    if (this._featureServer.documentInfo && this._featureServer.documentInfo.Author && this._featureServer.documentInfo.Author.length > 0) {
      return this._featureServer.documentInfo.Author;
    }
  }
  static async load(catalogGroup) {
    const uri = new URI(catalogGroup.url).addQuery("f", "json");
    if (catalogGroup.token) {
      uri.addQuery("token", catalogGroup.token);
    }
    return loadJson(proxyCatalogItemUrl(catalogGroup, uri.toString())).then(featureServer => {
      // Is this really a FeatureServer REST response?
      if (!featureServer || !featureServer.layers) {
        throw networkRequestError({
          title: i18next.t("models.arcGisFeatureServerCatalogGroup.invalidServiceTitle"),
          message: i18next.t("models.arcGisFeatureServerCatalogGroup.invalidServiceMessage")
        });
      }
      const stratum = new FeatureServerStratum(catalogGroup, featureServer);
      return stratum;
    }).catch(() => {
      throw networkRequestError({
        sender: catalogGroup,
        title: i18next.t("models.arcGisFeatureServerCatalogGroup.groupNotAvailableTitle"),
        message: i18next.t("models.arcGisFeatureServerCatalogGroup.groupNotAvailableMessage")
      });
    });
  }
  get members() {
    return filterOutUndefined(this.layers.map(layer => {
      if (!isDefined(layer.id)) {
        return undefined;
      }
      return this._catalogGroup.uniqueId + "/" + layer.id;
    }));
  }
  get layers() {
    return this._featureServer.layers;
  }
  createMembersFromLayers() {
    this.layers.forEach(layer => this.createMemberFromLayer(layer));
  }
  createMemberFromLayer(layer) {
    if (!isDefined(layer.id)) {
      return;
    }
    const id = this._catalogGroup.uniqueId;
    const layerId = id + "/" + layer.id;
    const existingModel = this._catalogGroup.terria.getModelById(ArcGisFeatureServerCatalogItem, layerId);
    let model;
    if (existingModel === undefined) {
      model = new ArcGisFeatureServerCatalogItem(layerId, this._catalogGroup.terria);
      this._catalogGroup.terria.addModel(model);
    } else {
      model = existingModel;
    }

    // Replace the stratum inherited from the parent group.
    model.strata.delete(CommonStrata.definition);
    model.setTrait(CommonStrata.definition, "name", replaceUnderscores(layer.name));
    const uri = new URI(this._catalogGroup.url).segment(layer.id + ""); // Convert layer id to string as segment(0) means sthg different.
    model.setTrait(CommonStrata.definition, "url", uri.toString());
    if (this._catalogGroup.token) {
      model.setTrait(CommonStrata.definition, "token", this._catalogGroup.token);
    }
  }
}, _defineProperty(_FeatureServerStratum, "stratumName", "featureServer"), _FeatureServerStratum), _applyDecoratedDescriptor(_class.prototype, "name", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "name"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "info", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "info"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cacheDuration", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "cacheDuration"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dataCustodian", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "dataCustodian"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "members", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "members"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "layers", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "layers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createMembersFromLayers", [action], Object.getOwnPropertyDescriptor(_class.prototype, "createMembersFromLayers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createMemberFromLayer", [action], Object.getOwnPropertyDescriptor(_class.prototype, "createMemberFromLayer"), _class.prototype), _class);
StratumOrder.addLoadStratum(FeatureServerStratum.stratumName);
export default class ArcGisFeatureServerCatalogGroup extends UrlMixin(GroupMixin(CatalogMemberMixin(CreateModel(ArcGisFeatureServerCatalogGroupTraits)))) {
  get type() {
    return ArcGisFeatureServerCatalogGroup.type;
  }
  get typeName() {
    return i18next.t("models.arcGisFeatureServerCatalogGroup.name");
  }
  forceLoadMetadata() {
    return FeatureServerStratum.load(this).then(stratum => {
      runInAction(() => {
        this.strata.set(FeatureServerStratum.stratumName, stratum);
      });
    });
  }
  async forceLoadMembers() {
    const featureServerStratum = this.strata.get(FeatureServerStratum.stratumName);
    if (featureServerStratum) {
      await runLater(() => featureServerStratum.createMembersFromLayers());
    }
  }
}
_defineProperty(ArcGisFeatureServerCatalogGroup, "type", "esri-featureServer-group");